
namespace RioERP.Masters {
    export class SmsTemplateVariablesColumns {
        static columnsKey = 'Masters.SmsTemplateVariables';
    }
}